export default [


    {
        header: 'Historique',
        module: 'HistoryRelance',
        profile: ['Admin','AdminSuper'],
    },
    {
        title: 'Mails de Relance',
        route: 'historyRelance',
        icon: 'ArchiveIcon',
        module: 'HistoryRelance',
        profile: ['Admin','AdminSuper']
    },
   
]